// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"dropdown-menu_component_dropdownMenu__0cD4_"};